@file:OptIn(InternalResourceApi::class)

package klyph.sample.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/klyph.sample.generated.resources/"

@delegate:ResourceContentHash(-1_517_359_639)
internal val Res.font._008abaf300b818ffbc9fefbf62f14855a3c5602b: FontResource by lazy {
      FontResource("font:_008abaf300b818ffbc9fefbf62f14855a3c5602b", setOf(
        ResourceItem(setOf(), "${MD}font/_008abaf300b818ffbc9fefbf62f14855a3c5602b.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_879_609_303)
internal val Res.font._0094d712a49c0f7e145445fe781e349ad3cd2f96: FontResource by lazy {
      FontResource("font:_0094d712a49c0f7e145445fe781e349ad3cd2f96", setOf(
        ResourceItem(setOf(), "${MD}font/_0094d712a49c0f7e145445fe781e349ad3cd2f96.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(803_640_988)
internal val Res.font._01779b0a39a2c388f78004d4a0e6011803347392: FontResource by lazy {
      FontResource("font:_01779b0a39a2c388f78004d4a0e6011803347392", setOf(
        ResourceItem(setOf(), "${MD}font/_01779b0a39a2c388f78004d4a0e6011803347392.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-525_186_066)
internal val Res.font._01d03d9b2680d88faf06bc181b2ca7ce82348a59: FontResource by lazy {
      FontResource("font:_01d03d9b2680d88faf06bc181b2ca7ce82348a59", setOf(
        ResourceItem(setOf(), "${MD}font/_01d03d9b2680d88faf06bc181b2ca7ce82348a59.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_577_964_376)
internal val Res.font._020343678e14cfd2df8b61c62b2b55331eee64a3: FontResource by lazy {
      FontResource("font:_020343678e14cfd2df8b61c62b2b55331eee64a3", setOf(
        ResourceItem(setOf(), "${MD}font/_020343678e14cfd2df8b61c62b2b55331eee64a3.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_371_673_985)
internal val Res.font._036b8294dc7ed2dc06becfcfa2044b42c16dcfd8: FontResource by lazy {
      FontResource("font:_036b8294dc7ed2dc06becfcfa2044b42c16dcfd8", setOf(
        ResourceItem(setOf(), "${MD}font/_036b8294dc7ed2dc06becfcfa2044b42c16dcfd8.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(44_740_016)
internal val Res.font._039f6b951dabb799ec1b0e9f8c31c305311dff86: FontResource by lazy {
      FontResource("font:_039f6b951dabb799ec1b0e9f8c31c305311dff86", setOf(
        ResourceItem(setOf(), "${MD}font/_039f6b951dabb799ec1b0e9f8c31c305311dff86.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(993_210_546)
internal val Res.font._06512088d7431e0c42f2212a61fa7e411498a81d: FontResource by lazy {
      FontResource("font:_06512088d7431e0c42f2212a61fa7e411498a81d", setOf(
        ResourceItem(setOf(), "${MD}font/_06512088d7431e0c42f2212a61fa7e411498a81d.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_930_471_893)
internal val Res.font._069499d3877a0081a89217d124bfcb0f94ff2140: FontResource by lazy {
      FontResource("font:_069499d3877a0081a89217d124bfcb0f94ff2140", setOf(
        ResourceItem(setOf(), "${MD}font/_069499d3877a0081a89217d124bfcb0f94ff2140.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(441_140_703)
internal val Res.font._093af109a561fcd5734eea8f18855676cceb72bd: FontResource by lazy {
      FontResource("font:_093af109a561fcd5734eea8f18855676cceb72bd", setOf(
        ResourceItem(setOf(), "${MD}font/_093af109a561fcd5734eea8f18855676cceb72bd.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_773_696_293)
internal val Res.font._09cabf1195eab0ed6decd9e33e84b1b010d5dfd3: FontResource by lazy {
      FontResource("font:_09cabf1195eab0ed6decd9e33e84b1b010d5dfd3", setOf(
        ResourceItem(setOf(), "${MD}font/_09cabf1195eab0ed6decd9e33e84b1b010d5dfd3.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-437_888_220)
internal val Res.font._09e822706538ff699a6263952e32cf161425ab6a: FontResource by lazy {
      FontResource("font:_09e822706538ff699a6263952e32cf161425ab6a", setOf(
        ResourceItem(setOf(), "${MD}font/_09e822706538ff699a6263952e32cf161425ab6a.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-421_696_091)
internal val Res.font._0bea61ef1bf718339d069b6ac5fb2d2a2892f71a: FontResource by lazy {
      FontResource("font:_0bea61ef1bf718339d069b6ac5fb2d2a2892f71a", setOf(
        ResourceItem(setOf(), "${MD}font/_0bea61ef1bf718339d069b6ac5fb2d2a2892f71a.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-812_789_780)
internal val Res.font._0ca1ca392b46eb259a7eae6a1332152736988f13: FontResource by lazy {
      FontResource("font:_0ca1ca392b46eb259a7eae6a1332152736988f13", setOf(
        ResourceItem(setOf(), "${MD}font/_0ca1ca392b46eb259a7eae6a1332152736988f13.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-678_294_878)
internal val Res.font._0d5619cd76be384a3947473dcf6261fdeab3ac60: FontResource by lazy {
      FontResource("font:_0d5619cd76be384a3947473dcf6261fdeab3ac60", setOf(
        ResourceItem(setOf(), "${MD}font/_0d5619cd76be384a3947473dcf6261fdeab3ac60.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_421_463_611)
internal val Res.font._114f3f54e4ae9f294e2bc1d759df0d4c35b29c0a: FontResource by lazy {
      FontResource("font:_114f3f54e4ae9f294e2bc1d759df0d4c35b29c0a", setOf(
        ResourceItem(setOf(), "${MD}font/_114f3f54e4ae9f294e2bc1d759df0d4c35b29c0a.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-281_294_143)
internal val Res.font._13ca82eaa478567408223d059912eaa64a3b1355: FontResource by lazy {
      FontResource("font:_13ca82eaa478567408223d059912eaa64a3b1355", setOf(
        ResourceItem(setOf(), "${MD}font/_13ca82eaa478567408223d059912eaa64a3b1355.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-551_317_052)
internal val Res.font._13e31b4657af7b27267fb0bf65801f9afb5651cd: FontResource by lazy {
      FontResource("font:_13e31b4657af7b27267fb0bf65801f9afb5651cd", setOf(
        ResourceItem(setOf(), "${MD}font/_13e31b4657af7b27267fb0bf65801f9afb5651cd.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_921_573_057)
internal val Res.font._154c2cee315937d73c2a28036aa73f7186c74601: FontResource by lazy {
      FontResource("font:_154c2cee315937d73c2a28036aa73f7186c74601", setOf(
        ResourceItem(setOf(), "${MD}font/_154c2cee315937d73c2a28036aa73f7186c74601.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-771_771_519)
internal val Res.font._15920446e4a89c6cfd1227ea01b0aa80a00a3740: FontResource by lazy {
      FontResource("font:_15920446e4a89c6cfd1227ea01b0aa80a00a3740", setOf(
        ResourceItem(setOf(), "${MD}font/_15920446e4a89c6cfd1227ea01b0aa80a00a3740.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(176_666_707)
internal val Res.font._15dc5349ccb5e2602325c74cdcf2c3b7ca7f7afc: FontResource by lazy {
      FontResource("font:_15dc5349ccb5e2602325c74cdcf2c3b7ca7f7afc", setOf(
        ResourceItem(setOf(), "${MD}font/_15dc5349ccb5e2602325c74cdcf2c3b7ca7f7afc.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_945_181_193)
internal val Res.font._15dd353cf2eb6aab7852beb9170b8dc47375c68b: FontResource by lazy {
      FontResource("font:_15dd353cf2eb6aab7852beb9170b8dc47375c68b", setOf(
        ResourceItem(setOf(), "${MD}font/_15dd353cf2eb6aab7852beb9170b8dc47375c68b.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-975_545_846)
internal val Res.font._16c844156a8982e1c5a79b1199a7e4df4d278fb9: FontResource by lazy {
      FontResource("font:_16c844156a8982e1c5a79b1199a7e4df4d278fb9", setOf(
        ResourceItem(setOf(), "${MD}font/_16c844156a8982e1c5a79b1199a7e4df4d278fb9.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_249_054_553)
internal val Res.font._19a2144c1340fca5d26d8d62ab3299e8a2da1b7d: FontResource by lazy {
      FontResource("font:_19a2144c1340fca5d26d8d62ab3299e8a2da1b7d", setOf(
        ResourceItem(setOf(), "${MD}font/_19a2144c1340fca5d26d8d62ab3299e8a2da1b7d.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_340_832_102)
internal val Res.font._1a141b53496589434a352ff562d5624453de035c: FontResource by lazy {
      FontResource("font:_1a141b53496589434a352ff562d5624453de035c", setOf(
        ResourceItem(setOf(), "${MD}font/_1a141b53496589434a352ff562d5624453de035c.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_808_707_977)
internal val Res.font._1cfd68c870cb092c6cc0db26d7feeb9ce044f5b7: FontResource by lazy {
      FontResource("font:_1cfd68c870cb092c6cc0db26d7feeb9ce044f5b7", setOf(
        ResourceItem(setOf(), "${MD}font/_1cfd68c870cb092c6cc0db26d7feeb9ce044f5b7.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_487_038_852)
internal val Res.font._1e45c2c919f740ce7e1e34d887b8866a5c6b44f5: FontResource by lazy {
      FontResource("font:_1e45c2c919f740ce7e1e34d887b8866a5c6b44f5", setOf(
        ResourceItem(setOf(), "${MD}font/_1e45c2c919f740ce7e1e34d887b8866a5c6b44f5.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-834_741_763)
internal val Res.font._1e9c0dd8cd2896ca002c32d31b42c3cd0c585257: FontResource by lazy {
      FontResource("font:_1e9c0dd8cd2896ca002c32d31b42c3cd0c585257", setOf(
        ResourceItem(setOf(), "${MD}font/_1e9c0dd8cd2896ca002c32d31b42c3cd0c585257.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-146_241_379)
internal val Res.font._1f18c8acce181e061b987634484cab0ae60c566b: FontResource by lazy {
      FontResource("font:_1f18c8acce181e061b987634484cab0ae60c566b", setOf(
        ResourceItem(setOf(), "${MD}font/_1f18c8acce181e061b987634484cab0ae60c566b.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_868_492_226)
internal val Res.font._1fb83a94f4f848d66bbf8115fdf2d9fb734302d3: FontResource by lazy {
      FontResource("font:_1fb83a94f4f848d66bbf8115fdf2d9fb734302d3", setOf(
        ResourceItem(setOf(), "${MD}font/_1fb83a94f4f848d66bbf8115fdf2d9fb734302d3.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_218_904_459)
internal val Res.font._202449700de556feab10f5be198beb3d65ce4f8d: FontResource by lazy {
      FontResource("font:_202449700de556feab10f5be198beb3d65ce4f8d", setOf(
        ResourceItem(setOf(), "${MD}font/_202449700de556feab10f5be198beb3d65ce4f8d.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_334_556_219)
internal val Res.font._23172f9a721c2ef318c0e2aa62e6a6a783fc6f57: FontResource by lazy {
      FontResource("font:_23172f9a721c2ef318c0e2aa62e6a6a783fc6f57", setOf(
        ResourceItem(setOf(), "${MD}font/_23172f9a721c2ef318c0e2aa62e6a6a783fc6f57.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(423_771_399)
internal val Res.font._24e90e673077608462c03518f3384bfa7d72e46e: FontResource by lazy {
      FontResource("font:_24e90e673077608462c03518f3384bfa7d72e46e", setOf(
        ResourceItem(setOf(), "${MD}font/_24e90e673077608462c03518f3384bfa7d72e46e.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(853_604_901)
internal val Res.font._263283f03747e33fb33e63bd8ea54f168ee9a266: FontResource by lazy {
      FontResource("font:_263283f03747e33fb33e63bd8ea54f168ee9a266", setOf(
        ResourceItem(setOf(), "${MD}font/_263283f03747e33fb33e63bd8ea54f168ee9a266.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_472_408_553)
internal val Res.font._268f5e951f158a433772ea0abc9110f8e5914453: FontResource by lazy {
      FontResource("font:_268f5e951f158a433772ea0abc9110f8e5914453", setOf(
        ResourceItem(setOf(), "${MD}font/_268f5e951f158a433772ea0abc9110f8e5914453.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_057_360_120)
internal val Res.font._2a59c8f7f373892044717159037cb5cdf56af619: FontResource by lazy {
      FontResource("font:_2a59c8f7f373892044717159037cb5cdf56af619", setOf(
        ResourceItem(setOf(), "${MD}font/_2a59c8f7f373892044717159037cb5cdf56af619.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_807_319_873)
internal val Res.font._2ca4aecb5674bbdf1d565438f9f5b89fe39d3aac: FontResource by lazy {
      FontResource("font:_2ca4aecb5674bbdf1d565438f9f5b89fe39d3aac", setOf(
        ResourceItem(setOf(), "${MD}font/_2ca4aecb5674bbdf1d565438f9f5b89fe39d3aac.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_040_439_333)
internal val Res.font._2df3dbef5e2ae7603c477b24d10ed248c1cfedf3: FontResource by lazy {
      FontResource("font:_2df3dbef5e2ae7603c477b24d10ed248c1cfedf3", setOf(
        ResourceItem(setOf(), "${MD}font/_2df3dbef5e2ae7603c477b24d10ed248c1cfedf3.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_612_984_556)
internal val Res.font._2e8fa5a9a425bb36d6b3db5c8c33363b61148353: FontResource by lazy {
      FontResource("font:_2e8fa5a9a425bb36d6b3db5c8c33363b61148353", setOf(
        ResourceItem(setOf(), "${MD}font/_2e8fa5a9a425bb36d6b3db5c8c33363b61148353.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(656_753_418)
internal val Res.font._2edbdae714c7516b85a5f5dfa45dfbe88d97ac50: FontResource by lazy {
      FontResource("font:_2edbdae714c7516b85a5f5dfa45dfbe88d97ac50", setOf(
        ResourceItem(setOf(), "${MD}font/_2edbdae714c7516b85a5f5dfa45dfbe88d97ac50.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-775_400_717)
internal val Res.font._2f8f833775d6502bb84c656bc9bd3c614bb8a572: FontResource by lazy {
      FontResource("font:_2f8f833775d6502bb84c656bc9bd3c614bb8a572", setOf(
        ResourceItem(setOf(), "${MD}font/_2f8f833775d6502bb84c656bc9bd3c614bb8a572.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-368_384_919)
internal val Res.font._2f8fc6bdbccf9ac4e944d5fcd220820712b260af: FontResource by lazy {
      FontResource("font:_2f8fc6bdbccf9ac4e944d5fcd220820712b260af", setOf(
        ResourceItem(setOf(), "${MD}font/_2f8fc6bdbccf9ac4e944d5fcd220820712b260af.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_982_047_233)
internal val Res.font._30263f5cc31eaf99ccdbbbe744f97a0286e9817a: FontResource by lazy {
      FontResource("font:_30263f5cc31eaf99ccdbbbe744f97a0286e9817a", setOf(
        ResourceItem(setOf(), "${MD}font/_30263f5cc31eaf99ccdbbbe744f97a0286e9817a.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_545_162_003)
internal val Res.font._32672a8c57c23757cc3623a7ec3587fc4607038c: FontResource by lazy {
      FontResource("font:_32672a8c57c23757cc3623a7ec3587fc4607038c", setOf(
        ResourceItem(setOf(), "${MD}font/_32672a8c57c23757cc3623a7ec3587fc4607038c.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_337_811_689)
internal val Res.font._33642fc3b70e2c08dc731d1eb561390a0b4e340b: FontResource by lazy {
      FontResource("font:_33642fc3b70e2c08dc731d1eb561390a0b4e340b", setOf(
        ResourceItem(setOf(), "${MD}font/_33642fc3b70e2c08dc731d1eb561390a0b4e340b.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-615_348_739)
internal val Res.font._33c2947fd40592ff297360b590eca671d47cbae1: FontResource by lazy {
      FontResource("font:_33c2947fd40592ff297360b590eca671d47cbae1", setOf(
        ResourceItem(setOf(), "${MD}font/_33c2947fd40592ff297360b590eca671d47cbae1.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_372_660_541)
internal val Res.font._34391e663bb38229094b29042af32ffdc7bfb79c: FontResource by lazy {
      FontResource("font:_34391e663bb38229094b29042af32ffdc7bfb79c", setOf(
        ResourceItem(setOf(), "${MD}font/_34391e663bb38229094b29042af32ffdc7bfb79c.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_118_168_675)
internal val Res.font._3579c0fdd5a842054bf13dc6688d287ef3554cd3: FontResource by lazy {
      FontResource("font:_3579c0fdd5a842054bf13dc6688d287ef3554cd3", setOf(
        ResourceItem(setOf(), "${MD}font/_3579c0fdd5a842054bf13dc6688d287ef3554cd3.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(939_724_440)
internal val Res.font._3656bb367f96ba085db66ec85cc6a91b9db7faea: FontResource by lazy {
      FontResource("font:_3656bb367f96ba085db66ec85cc6a91b9db7faea", setOf(
        ResourceItem(setOf(), "${MD}font/_3656bb367f96ba085db66ec85cc6a91b9db7faea.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_772_449_923)
internal val Res.font._392ad78e4e6a301ab8d5f1e9ba5e13f3b3606ee4: FontResource by lazy {
      FontResource("font:_392ad78e4e6a301ab8d5f1e9ba5e13f3b3606ee4", setOf(
        ResourceItem(setOf(), "${MD}font/_392ad78e4e6a301ab8d5f1e9ba5e13f3b3606ee4.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_339_247_258)
internal val Res.font._39438aa0d32b5145a5d1d56cf04b65d97fcd4b3c: FontResource by lazy {
      FontResource("font:_39438aa0d32b5145a5d1d56cf04b65d97fcd4b3c", setOf(
        ResourceItem(setOf(), "${MD}font/_39438aa0d32b5145a5d1d56cf04b65d97fcd4b3c.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_846_630_219)
internal val Res.font._39801192a64a2308c97f6733ac88f91fbca229ac: FontResource by lazy {
      FontResource("font:_39801192a64a2308c97f6733ac88f91fbca229ac", setOf(
        ResourceItem(setOf(), "${MD}font/_39801192a64a2308c97f6733ac88f91fbca229ac.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(754_499_558)
internal val Res.font._39ae58f790280d4f2977498464ebcafec923c727: FontResource by lazy {
      FontResource("font:_39ae58f790280d4f2977498464ebcafec923c727", setOf(
        ResourceItem(setOf(), "${MD}font/_39ae58f790280d4f2977498464ebcafec923c727.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(802_822_424)
internal val Res.font._3a37ad5adba0f4333d912c8ac35dbf8651ef41a5: FontResource by lazy {
      FontResource("font:_3a37ad5adba0f4333d912c8ac35dbf8651ef41a5", setOf(
        ResourceItem(setOf(), "${MD}font/_3a37ad5adba0f4333d912c8ac35dbf8651ef41a5.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_663_272_956)
internal val Res.font._3c1733d5a85ef6904a429d4e80ff4bc4826e134f: FontResource by lazy {
      FontResource("font:_3c1733d5a85ef6904a429d4e80ff4bc4826e134f", setOf(
        ResourceItem(setOf(), "${MD}font/_3c1733d5a85ef6904a429d4e80ff4bc4826e134f.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-92_278_474)
internal val Res.font._411e15a079c91c3a98320a0402db12e506c44cc6: FontResource by lazy {
      FontResource("font:_411e15a079c91c3a98320a0402db12e506c44cc6", setOf(
        ResourceItem(setOf(), "${MD}font/_411e15a079c91c3a98320a0402db12e506c44cc6.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(424_565_249)
internal val Res.font._4259b1626e7acebca70af973ab196478faf16ef8: FontResource by lazy {
      FontResource("font:_4259b1626e7acebca70af973ab196478faf16ef8", setOf(
        ResourceItem(setOf(), "${MD}font/_4259b1626e7acebca70af973ab196478faf16ef8.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-990_440_430)
internal val Res.font._43e1068c37e1062dc62d9cba571b6fff4b84797f: FontResource by lazy {
      FontResource("font:_43e1068c37e1062dc62d9cba571b6fff4b84797f", setOf(
        ResourceItem(setOf(), "${MD}font/_43e1068c37e1062dc62d9cba571b6fff4b84797f.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_235_678_562)
internal val Res.font._44cc7d8da5f9e0287ceb86357e4b37f2e94a8d60: FontResource by lazy {
      FontResource("font:_44cc7d8da5f9e0287ceb86357e4b37f2e94a8d60", setOf(
        ResourceItem(setOf(), "${MD}font/_44cc7d8da5f9e0287ceb86357e4b37f2e94a8d60.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(717_231_389)
internal val Res.font._4691b9ecd45fdedb3680a2a0863c3f2329d21eb9: FontResource by lazy {
      FontResource("font:_4691b9ecd45fdedb3680a2a0863c3f2329d21eb9", setOf(
        ResourceItem(setOf(), "${MD}font/_4691b9ecd45fdedb3680a2a0863c3f2329d21eb9.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_058_318_465)
internal val Res.font._480e82828aba2bb45465583a0e855219e14bc0c6: FontResource by lazy {
      FontResource("font:_480e82828aba2bb45465583a0e855219e14bc0c6", setOf(
        ResourceItem(setOf(), "${MD}font/_480e82828aba2bb45465583a0e855219e14bc0c6.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_009_628_228)
internal val Res.font._482f326bdce7c0ca5b810fd44ba877d1394ee2b7: FontResource by lazy {
      FontResource("font:_482f326bdce7c0ca5b810fd44ba877d1394ee2b7", setOf(
        ResourceItem(setOf(), "${MD}font/_482f326bdce7c0ca5b810fd44ba877d1394ee2b7.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_737_882_254)
internal val Res.font._48c0f3aa44c1ae605ee3fbc35c0576ea914f295a: FontResource by lazy {
      FontResource("font:_48c0f3aa44c1ae605ee3fbc35c0576ea914f295a", setOf(
        ResourceItem(setOf(), "${MD}font/_48c0f3aa44c1ae605ee3fbc35c0576ea914f295a.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(672_925_374)
internal val Res.font._48dacca587b0875fe0d3e9ff299b5f8d8972c540: FontResource by lazy {
      FontResource("font:_48dacca587b0875fe0d3e9ff299b5f8d8972c540", setOf(
        ResourceItem(setOf(), "${MD}font/_48dacca587b0875fe0d3e9ff299b5f8d8972c540.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-405_938_476)
internal val Res.font._48e908c83d1e48d70db663cbec5d863e3b0666d5: FontResource by lazy {
      FontResource("font:_48e908c83d1e48d70db663cbec5d863e3b0666d5", setOf(
        ResourceItem(setOf(), "${MD}font/_48e908c83d1e48d70db663cbec5d863e3b0666d5.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(922_865_247)
internal val Res.font._499f7bfd2c93d8cff0dac1932f1050d8140c66c7: FontResource by lazy {
      FontResource("font:_499f7bfd2c93d8cff0dac1932f1050d8140c66c7", setOf(
        ResourceItem(setOf(), "${MD}font/_499f7bfd2c93d8cff0dac1932f1050d8140c66c7.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_411_721_698)
internal val Res.font._49d66c358c0a3e65a23e59aba8ae732c0d2bbf5b: FontResource by lazy {
      FontResource("font:_49d66c358c0a3e65a23e59aba8ae732c0d2bbf5b", setOf(
        ResourceItem(setOf(), "${MD}font/_49d66c358c0a3e65a23e59aba8ae732c0d2bbf5b.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_559_349_875)
internal val Res.font._4c079580414ada5159bc1975db9b23fbf0ba9090: FontResource by lazy {
      FontResource("font:_4c079580414ada5159bc1975db9b23fbf0ba9090", setOf(
        ResourceItem(setOf(), "${MD}font/_4c079580414ada5159bc1975db9b23fbf0ba9090.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(627_993_837)
internal val Res.font._4e12a5e93f54884fa6678b72675b069b049ff0fd: FontResource by lazy {
      FontResource("font:_4e12a5e93f54884fa6678b72675b069b049ff0fd", setOf(
        ResourceItem(setOf(), "${MD}font/_4e12a5e93f54884fa6678b72675b069b049ff0fd.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_127_551_161)
internal val Res.font._4e33961bdf0bd745d2badb722306894427201511: FontResource by lazy {
      FontResource("font:_4e33961bdf0bd745d2badb722306894427201511", setOf(
        ResourceItem(setOf(), "${MD}font/_4e33961bdf0bd745d2badb722306894427201511.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(366_317_499)
internal val Res.font._4e4d48ed6834c27b7a73ceadff42df23193753f7: FontResource by lazy {
      FontResource("font:_4e4d48ed6834c27b7a73ceadff42df23193753f7", setOf(
        ResourceItem(setOf(), "${MD}font/_4e4d48ed6834c27b7a73ceadff42df23193753f7.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_798_590_651)
internal val Res.font._4e59f2f2c0472c74869ebb27cb877ce2a74d4a9e: FontResource by lazy {
      FontResource("font:_4e59f2f2c0472c74869ebb27cb877ce2a74d4a9e", setOf(
        ResourceItem(setOf(), "${MD}font/_4e59f2f2c0472c74869ebb27cb877ce2a74d4a9e.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_030_964_140)
internal val Res.font._4f23d6c9b7561411554fdd140a53bcc738db42a1: FontResource by lazy {
      FontResource("font:_4f23d6c9b7561411554fdd140a53bcc738db42a1", setOf(
        ResourceItem(setOf(), "${MD}font/_4f23d6c9b7561411554fdd140a53bcc738db42a1.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_079_052_918)
internal val Res.font._4f5544db2482521612ebab149012f025acf6cd78: FontResource by lazy {
      FontResource("font:_4f5544db2482521612ebab149012f025acf6cd78", setOf(
        ResourceItem(setOf(), "${MD}font/_4f5544db2482521612ebab149012f025acf6cd78.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_347_711_080)
internal val Res.font._505df79fb9a595fa0fa8c5c0059f4a9a0d1b0626: FontResource by lazy {
      FontResource("font:_505df79fb9a595fa0fa8c5c0059f4a9a0d1b0626", setOf(
        ResourceItem(setOf(), "${MD}font/_505df79fb9a595fa0fa8c5c0059f4a9a0d1b0626.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_253_835_109)
internal val Res.font._50de6d5e13137f4d37be2aef8078641c2ca7fc38: FontResource by lazy {
      FontResource("font:_50de6d5e13137f4d37be2aef8078641c2ca7fc38", setOf(
        ResourceItem(setOf(), "${MD}font/_50de6d5e13137f4d37be2aef8078641c2ca7fc38.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_146_685_041)
internal val Res.font._52274cf09510a6a195b4ce72643f80eac58fe183: FontResource by lazy {
      FontResource("font:_52274cf09510a6a195b4ce72643f80eac58fe183", setOf(
        ResourceItem(setOf(), "${MD}font/_52274cf09510a6a195b4ce72643f80eac58fe183.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_347_690_646)
internal val Res.font._52896402e6b7771a2dc4d9eff5772e77e0275092: FontResource by lazy {
      FontResource("font:_52896402e6b7771a2dc4d9eff5772e77e0275092", setOf(
        ResourceItem(setOf(), "${MD}font/_52896402e6b7771a2dc4d9eff5772e77e0275092.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-718_603_838)
internal val Res.font._539d3795b07827a83ed5b491d8cfcb5a9a6405e2: FontResource by lazy {
      FontResource("font:_539d3795b07827a83ed5b491d8cfcb5a9a6405e2", setOf(
        ResourceItem(setOf(), "${MD}font/_539d3795b07827a83ed5b491d8cfcb5a9a6405e2.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(933_877_832)
internal val Res.font._543049ac56a8b9c81f4e5f9c35c49e60d6c630a5: FontResource by lazy {
      FontResource("font:_543049ac56a8b9c81f4e5f9c35c49e60d6c630a5", setOf(
        ResourceItem(setOf(), "${MD}font/_543049ac56a8b9c81f4e5f9c35c49e60d6c630a5.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_054_267_170)
internal val Res.font._54928fe52b56f2e55e90305d1169453982003c6f: FontResource by lazy {
      FontResource("font:_54928fe52b56f2e55e90305d1169453982003c6f", setOf(
        ResourceItem(setOf(), "${MD}font/_54928fe52b56f2e55e90305d1169453982003c6f.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_811_569_546)
internal val Res.font._570b35e41ba264a1fd9faa52a39e1987f8f5bcf3: FontResource by lazy {
      FontResource("font:_570b35e41ba264a1fd9faa52a39e1987f8f5bcf3", setOf(
        ResourceItem(setOf(), "${MD}font/_570b35e41ba264a1fd9faa52a39e1987f8f5bcf3.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_858_446_222)
internal val Res.font._5729e1c7761e516ac83883ffd140a92b1512f628: FontResource by lazy {
      FontResource("font:_5729e1c7761e516ac83883ffd140a92b1512f628", setOf(
        ResourceItem(setOf(), "${MD}font/_5729e1c7761e516ac83883ffd140a92b1512f628.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-308_446_798)
internal val Res.font._58fe1853b627974ca3a76b029079b61b219c8f0f: FontResource by lazy {
      FontResource("font:_58fe1853b627974ca3a76b029079b61b219c8f0f", setOf(
        ResourceItem(setOf(), "${MD}font/_58fe1853b627974ca3a76b029079b61b219c8f0f.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-838_250_561)
internal val Res.font._593e97e2385222fe18f50d73ba594f31d98e7531: FontResource by lazy {
      FontResource("font:_593e97e2385222fe18f50d73ba594f31d98e7531", setOf(
        ResourceItem(setOf(), "${MD}font/_593e97e2385222fe18f50d73ba594f31d98e7531.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-324_202_213)
internal val Res.font._5b039e40b4aaa71b56030c1692b11dbd783637b6: FontResource by lazy {
      FontResource("font:_5b039e40b4aaa71b56030c1692b11dbd783637b6", setOf(
        ResourceItem(setOf(), "${MD}font/_5b039e40b4aaa71b56030c1692b11dbd783637b6.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_853_847_524)
internal val Res.font._5d4fbfdc9fcb2c4d2cf8814448fdc46d7a2bbe48: FontResource by lazy {
      FontResource("font:_5d4fbfdc9fcb2c4d2cf8814448fdc46d7a2bbe48", setOf(
        ResourceItem(setOf(), "${MD}font/_5d4fbfdc9fcb2c4d2cf8814448fdc46d7a2bbe48.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-960_693_507)
internal val Res.font._5f6d5d48a48829abbb642a10481c6267627fa0bc: FontResource by lazy {
      FontResource("font:_5f6d5d48a48829abbb642a10481c6267627fa0bc", setOf(
        ResourceItem(setOf(), "${MD}font/_5f6d5d48a48829abbb642a10481c6267627fa0bc.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-227_353_910)
internal val Res.font._64a68f4eae9f8eca1ba72d34a3afbabf42b32af4: FontResource by lazy {
      FontResource("font:_64a68f4eae9f8eca1ba72d34a3afbabf42b32af4", setOf(
        ResourceItem(setOf(), "${MD}font/_64a68f4eae9f8eca1ba72d34a3afbabf42b32af4.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(484_484_000)
internal val Res.font._65d1ed68bc27b4f400fbcafe0ea531a9a087f4ff: FontResource by lazy {
      FontResource("font:_65d1ed68bc27b4f400fbcafe0ea531a9a087f4ff", setOf(
        ResourceItem(setOf(), "${MD}font/_65d1ed68bc27b4f400fbcafe0ea531a9a087f4ff.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_258_441_268)
internal val Res.font._68a5464007723777ad19739c2b9f61ae7b20fb29: FontResource by lazy {
      FontResource("font:_68a5464007723777ad19739c2b9f61ae7b20fb29", setOf(
        ResourceItem(setOf(), "${MD}font/_68a5464007723777ad19739c2b9f61ae7b20fb29.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_751_961_881)
internal val Res.font._6a3a3f15d55c26754030feb18032178e5ff3d7bd: FontResource by lazy {
      FontResource("font:_6a3a3f15d55c26754030feb18032178e5ff3d7bd", setOf(
        ResourceItem(setOf(), "${MD}font/_6a3a3f15d55c26754030feb18032178e5ff3d7bd.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(199_171_819)
internal val Res.font._6a44adc74548e99ac32246f1aed58256daf019b2: FontResource by lazy {
      FontResource("font:_6a44adc74548e99ac32246f1aed58256daf019b2", setOf(
        ResourceItem(setOf(), "${MD}font/_6a44adc74548e99ac32246f1aed58256daf019b2.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(524_297_510)
internal val Res.font._6acd0f9f24e86d424fd103ae184d1e4a0589af1b: FontResource by lazy {
      FontResource("font:_6acd0f9f24e86d424fd103ae184d1e4a0589af1b", setOf(
        ResourceItem(setOf(), "${MD}font/_6acd0f9f24e86d424fd103ae184d1e4a0589af1b.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_128_675_472)
internal val Res.font._6c49cee9927a527f770b8486b002c85e1cde0588: FontResource by lazy {
      FontResource("font:_6c49cee9927a527f770b8486b002c85e1cde0588", setOf(
        ResourceItem(setOf(), "${MD}font/_6c49cee9927a527f770b8486b002c85e1cde0588.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_949_454_247)
internal val Res.font._6cb50e2d7f94d3c09289fe0bcb4cb5f5f5dd9f27: FontResource by lazy {
      FontResource("font:_6cb50e2d7f94d3c09289fe0bcb4cb5f5f5dd9f27", setOf(
        ResourceItem(setOf(), "${MD}font/_6cb50e2d7f94d3c09289fe0bcb4cb5f5f5dd9f27.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_199_550_567)
internal val Res.font._7267c3e070640c379c296cc430d8722abbaa0ae6: FontResource by lazy {
      FontResource("font:_7267c3e070640c379c296cc430d8722abbaa0ae6", setOf(
        ResourceItem(setOf(), "${MD}font/_7267c3e070640c379c296cc430d8722abbaa0ae6.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_570_738_601)
internal val Res.font._729c77bb3fe7d444083ba9362ee6d1e7292098da: FontResource by lazy {
      FontResource("font:_729c77bb3fe7d444083ba9362ee6d1e7292098da", setOf(
        ResourceItem(setOf(), "${MD}font/_729c77bb3fe7d444083ba9362ee6d1e7292098da.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(95_655_133)
internal val Res.font._7321156c853d99243c80be84200b8d1c7064b401: FontResource by lazy {
      FontResource("font:_7321156c853d99243c80be84200b8d1c7064b401", setOf(
        ResourceItem(setOf(), "${MD}font/_7321156c853d99243c80be84200b8d1c7064b401.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_170_044_552)
internal val Res.font._750675588f6cf2a66a3c02f0c4045317e42531a7: FontResource by lazy {
      FontResource("font:_750675588f6cf2a66a3c02f0c4045317e42531a7", setOf(
        ResourceItem(setOf(), "${MD}font/_750675588f6cf2a66a3c02f0c4045317e42531a7.woff2", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("_008abaf300b818ffbc9fefbf62f14855a3c5602b", Res.font._008abaf300b818ffbc9fefbf62f14855a3c5602b)
  map.put("_0094d712a49c0f7e145445fe781e349ad3cd2f96", Res.font._0094d712a49c0f7e145445fe781e349ad3cd2f96)
  map.put("_01779b0a39a2c388f78004d4a0e6011803347392", Res.font._01779b0a39a2c388f78004d4a0e6011803347392)
  map.put("_01d03d9b2680d88faf06bc181b2ca7ce82348a59", Res.font._01d03d9b2680d88faf06bc181b2ca7ce82348a59)
  map.put("_020343678e14cfd2df8b61c62b2b55331eee64a3", Res.font._020343678e14cfd2df8b61c62b2b55331eee64a3)
  map.put("_036b8294dc7ed2dc06becfcfa2044b42c16dcfd8", Res.font._036b8294dc7ed2dc06becfcfa2044b42c16dcfd8)
  map.put("_039f6b951dabb799ec1b0e9f8c31c305311dff86", Res.font._039f6b951dabb799ec1b0e9f8c31c305311dff86)
  map.put("_06512088d7431e0c42f2212a61fa7e411498a81d", Res.font._06512088d7431e0c42f2212a61fa7e411498a81d)
  map.put("_069499d3877a0081a89217d124bfcb0f94ff2140", Res.font._069499d3877a0081a89217d124bfcb0f94ff2140)
  map.put("_093af109a561fcd5734eea8f18855676cceb72bd", Res.font._093af109a561fcd5734eea8f18855676cceb72bd)
  map.put("_09cabf1195eab0ed6decd9e33e84b1b010d5dfd3", Res.font._09cabf1195eab0ed6decd9e33e84b1b010d5dfd3)
  map.put("_09e822706538ff699a6263952e32cf161425ab6a", Res.font._09e822706538ff699a6263952e32cf161425ab6a)
  map.put("_0bea61ef1bf718339d069b6ac5fb2d2a2892f71a", Res.font._0bea61ef1bf718339d069b6ac5fb2d2a2892f71a)
  map.put("_0ca1ca392b46eb259a7eae6a1332152736988f13", Res.font._0ca1ca392b46eb259a7eae6a1332152736988f13)
  map.put("_0d5619cd76be384a3947473dcf6261fdeab3ac60", Res.font._0d5619cd76be384a3947473dcf6261fdeab3ac60)
  map.put("_114f3f54e4ae9f294e2bc1d759df0d4c35b29c0a", Res.font._114f3f54e4ae9f294e2bc1d759df0d4c35b29c0a)
  map.put("_13ca82eaa478567408223d059912eaa64a3b1355", Res.font._13ca82eaa478567408223d059912eaa64a3b1355)
  map.put("_13e31b4657af7b27267fb0bf65801f9afb5651cd", Res.font._13e31b4657af7b27267fb0bf65801f9afb5651cd)
  map.put("_154c2cee315937d73c2a28036aa73f7186c74601", Res.font._154c2cee315937d73c2a28036aa73f7186c74601)
  map.put("_15920446e4a89c6cfd1227ea01b0aa80a00a3740", Res.font._15920446e4a89c6cfd1227ea01b0aa80a00a3740)
  map.put("_15dc5349ccb5e2602325c74cdcf2c3b7ca7f7afc", Res.font._15dc5349ccb5e2602325c74cdcf2c3b7ca7f7afc)
  map.put("_15dd353cf2eb6aab7852beb9170b8dc47375c68b", Res.font._15dd353cf2eb6aab7852beb9170b8dc47375c68b)
  map.put("_16c844156a8982e1c5a79b1199a7e4df4d278fb9", Res.font._16c844156a8982e1c5a79b1199a7e4df4d278fb9)
  map.put("_19a2144c1340fca5d26d8d62ab3299e8a2da1b7d", Res.font._19a2144c1340fca5d26d8d62ab3299e8a2da1b7d)
  map.put("_1a141b53496589434a352ff562d5624453de035c", Res.font._1a141b53496589434a352ff562d5624453de035c)
  map.put("_1cfd68c870cb092c6cc0db26d7feeb9ce044f5b7", Res.font._1cfd68c870cb092c6cc0db26d7feeb9ce044f5b7)
  map.put("_1e45c2c919f740ce7e1e34d887b8866a5c6b44f5", Res.font._1e45c2c919f740ce7e1e34d887b8866a5c6b44f5)
  map.put("_1e9c0dd8cd2896ca002c32d31b42c3cd0c585257", Res.font._1e9c0dd8cd2896ca002c32d31b42c3cd0c585257)
  map.put("_1f18c8acce181e061b987634484cab0ae60c566b", Res.font._1f18c8acce181e061b987634484cab0ae60c566b)
  map.put("_1fb83a94f4f848d66bbf8115fdf2d9fb734302d3", Res.font._1fb83a94f4f848d66bbf8115fdf2d9fb734302d3)
  map.put("_202449700de556feab10f5be198beb3d65ce4f8d", Res.font._202449700de556feab10f5be198beb3d65ce4f8d)
  map.put("_23172f9a721c2ef318c0e2aa62e6a6a783fc6f57", Res.font._23172f9a721c2ef318c0e2aa62e6a6a783fc6f57)
  map.put("_24e90e673077608462c03518f3384bfa7d72e46e", Res.font._24e90e673077608462c03518f3384bfa7d72e46e)
  map.put("_263283f03747e33fb33e63bd8ea54f168ee9a266", Res.font._263283f03747e33fb33e63bd8ea54f168ee9a266)
  map.put("_268f5e951f158a433772ea0abc9110f8e5914453", Res.font._268f5e951f158a433772ea0abc9110f8e5914453)
  map.put("_2a59c8f7f373892044717159037cb5cdf56af619", Res.font._2a59c8f7f373892044717159037cb5cdf56af619)
  map.put("_2ca4aecb5674bbdf1d565438f9f5b89fe39d3aac", Res.font._2ca4aecb5674bbdf1d565438f9f5b89fe39d3aac)
  map.put("_2df3dbef5e2ae7603c477b24d10ed248c1cfedf3", Res.font._2df3dbef5e2ae7603c477b24d10ed248c1cfedf3)
  map.put("_2e8fa5a9a425bb36d6b3db5c8c33363b61148353", Res.font._2e8fa5a9a425bb36d6b3db5c8c33363b61148353)
  map.put("_2edbdae714c7516b85a5f5dfa45dfbe88d97ac50", Res.font._2edbdae714c7516b85a5f5dfa45dfbe88d97ac50)
  map.put("_2f8f833775d6502bb84c656bc9bd3c614bb8a572", Res.font._2f8f833775d6502bb84c656bc9bd3c614bb8a572)
  map.put("_2f8fc6bdbccf9ac4e944d5fcd220820712b260af", Res.font._2f8fc6bdbccf9ac4e944d5fcd220820712b260af)
  map.put("_30263f5cc31eaf99ccdbbbe744f97a0286e9817a", Res.font._30263f5cc31eaf99ccdbbbe744f97a0286e9817a)
  map.put("_32672a8c57c23757cc3623a7ec3587fc4607038c", Res.font._32672a8c57c23757cc3623a7ec3587fc4607038c)
  map.put("_33642fc3b70e2c08dc731d1eb561390a0b4e340b", Res.font._33642fc3b70e2c08dc731d1eb561390a0b4e340b)
  map.put("_33c2947fd40592ff297360b590eca671d47cbae1", Res.font._33c2947fd40592ff297360b590eca671d47cbae1)
  map.put("_34391e663bb38229094b29042af32ffdc7bfb79c", Res.font._34391e663bb38229094b29042af32ffdc7bfb79c)
  map.put("_3579c0fdd5a842054bf13dc6688d287ef3554cd3", Res.font._3579c0fdd5a842054bf13dc6688d287ef3554cd3)
  map.put("_3656bb367f96ba085db66ec85cc6a91b9db7faea", Res.font._3656bb367f96ba085db66ec85cc6a91b9db7faea)
  map.put("_392ad78e4e6a301ab8d5f1e9ba5e13f3b3606ee4", Res.font._392ad78e4e6a301ab8d5f1e9ba5e13f3b3606ee4)
  map.put("_39438aa0d32b5145a5d1d56cf04b65d97fcd4b3c", Res.font._39438aa0d32b5145a5d1d56cf04b65d97fcd4b3c)
  map.put("_39801192a64a2308c97f6733ac88f91fbca229ac", Res.font._39801192a64a2308c97f6733ac88f91fbca229ac)
  map.put("_39ae58f790280d4f2977498464ebcafec923c727", Res.font._39ae58f790280d4f2977498464ebcafec923c727)
  map.put("_3a37ad5adba0f4333d912c8ac35dbf8651ef41a5", Res.font._3a37ad5adba0f4333d912c8ac35dbf8651ef41a5)
  map.put("_3c1733d5a85ef6904a429d4e80ff4bc4826e134f", Res.font._3c1733d5a85ef6904a429d4e80ff4bc4826e134f)
  map.put("_411e15a079c91c3a98320a0402db12e506c44cc6", Res.font._411e15a079c91c3a98320a0402db12e506c44cc6)
  map.put("_4259b1626e7acebca70af973ab196478faf16ef8", Res.font._4259b1626e7acebca70af973ab196478faf16ef8)
  map.put("_43e1068c37e1062dc62d9cba571b6fff4b84797f", Res.font._43e1068c37e1062dc62d9cba571b6fff4b84797f)
  map.put("_44cc7d8da5f9e0287ceb86357e4b37f2e94a8d60", Res.font._44cc7d8da5f9e0287ceb86357e4b37f2e94a8d60)
  map.put("_4691b9ecd45fdedb3680a2a0863c3f2329d21eb9", Res.font._4691b9ecd45fdedb3680a2a0863c3f2329d21eb9)
  map.put("_480e82828aba2bb45465583a0e855219e14bc0c6", Res.font._480e82828aba2bb45465583a0e855219e14bc0c6)
  map.put("_482f326bdce7c0ca5b810fd44ba877d1394ee2b7", Res.font._482f326bdce7c0ca5b810fd44ba877d1394ee2b7)
  map.put("_48c0f3aa44c1ae605ee3fbc35c0576ea914f295a", Res.font._48c0f3aa44c1ae605ee3fbc35c0576ea914f295a)
  map.put("_48dacca587b0875fe0d3e9ff299b5f8d8972c540", Res.font._48dacca587b0875fe0d3e9ff299b5f8d8972c540)
  map.put("_48e908c83d1e48d70db663cbec5d863e3b0666d5", Res.font._48e908c83d1e48d70db663cbec5d863e3b0666d5)
  map.put("_499f7bfd2c93d8cff0dac1932f1050d8140c66c7", Res.font._499f7bfd2c93d8cff0dac1932f1050d8140c66c7)
  map.put("_49d66c358c0a3e65a23e59aba8ae732c0d2bbf5b", Res.font._49d66c358c0a3e65a23e59aba8ae732c0d2bbf5b)
  map.put("_4c079580414ada5159bc1975db9b23fbf0ba9090", Res.font._4c079580414ada5159bc1975db9b23fbf0ba9090)
  map.put("_4e12a5e93f54884fa6678b72675b069b049ff0fd", Res.font._4e12a5e93f54884fa6678b72675b069b049ff0fd)
  map.put("_4e33961bdf0bd745d2badb722306894427201511", Res.font._4e33961bdf0bd745d2badb722306894427201511)
  map.put("_4e4d48ed6834c27b7a73ceadff42df23193753f7", Res.font._4e4d48ed6834c27b7a73ceadff42df23193753f7)
  map.put("_4e59f2f2c0472c74869ebb27cb877ce2a74d4a9e", Res.font._4e59f2f2c0472c74869ebb27cb877ce2a74d4a9e)
  map.put("_4f23d6c9b7561411554fdd140a53bcc738db42a1", Res.font._4f23d6c9b7561411554fdd140a53bcc738db42a1)
  map.put("_4f5544db2482521612ebab149012f025acf6cd78", Res.font._4f5544db2482521612ebab149012f025acf6cd78)
  map.put("_505df79fb9a595fa0fa8c5c0059f4a9a0d1b0626", Res.font._505df79fb9a595fa0fa8c5c0059f4a9a0d1b0626)
  map.put("_50de6d5e13137f4d37be2aef8078641c2ca7fc38", Res.font._50de6d5e13137f4d37be2aef8078641c2ca7fc38)
  map.put("_52274cf09510a6a195b4ce72643f80eac58fe183", Res.font._52274cf09510a6a195b4ce72643f80eac58fe183)
  map.put("_52896402e6b7771a2dc4d9eff5772e77e0275092", Res.font._52896402e6b7771a2dc4d9eff5772e77e0275092)
  map.put("_539d3795b07827a83ed5b491d8cfcb5a9a6405e2", Res.font._539d3795b07827a83ed5b491d8cfcb5a9a6405e2)
  map.put("_543049ac56a8b9c81f4e5f9c35c49e60d6c630a5", Res.font._543049ac56a8b9c81f4e5f9c35c49e60d6c630a5)
  map.put("_54928fe52b56f2e55e90305d1169453982003c6f", Res.font._54928fe52b56f2e55e90305d1169453982003c6f)
  map.put("_570b35e41ba264a1fd9faa52a39e1987f8f5bcf3", Res.font._570b35e41ba264a1fd9faa52a39e1987f8f5bcf3)
  map.put("_5729e1c7761e516ac83883ffd140a92b1512f628", Res.font._5729e1c7761e516ac83883ffd140a92b1512f628)
  map.put("_58fe1853b627974ca3a76b029079b61b219c8f0f", Res.font._58fe1853b627974ca3a76b029079b61b219c8f0f)
  map.put("_593e97e2385222fe18f50d73ba594f31d98e7531", Res.font._593e97e2385222fe18f50d73ba594f31d98e7531)
  map.put("_5b039e40b4aaa71b56030c1692b11dbd783637b6", Res.font._5b039e40b4aaa71b56030c1692b11dbd783637b6)
  map.put("_5d4fbfdc9fcb2c4d2cf8814448fdc46d7a2bbe48", Res.font._5d4fbfdc9fcb2c4d2cf8814448fdc46d7a2bbe48)
  map.put("_5f6d5d48a48829abbb642a10481c6267627fa0bc", Res.font._5f6d5d48a48829abbb642a10481c6267627fa0bc)
  map.put("_64a68f4eae9f8eca1ba72d34a3afbabf42b32af4", Res.font._64a68f4eae9f8eca1ba72d34a3afbabf42b32af4)
  map.put("_65d1ed68bc27b4f400fbcafe0ea531a9a087f4ff", Res.font._65d1ed68bc27b4f400fbcafe0ea531a9a087f4ff)
  map.put("_68a5464007723777ad19739c2b9f61ae7b20fb29", Res.font._68a5464007723777ad19739c2b9f61ae7b20fb29)
  map.put("_6a3a3f15d55c26754030feb18032178e5ff3d7bd", Res.font._6a3a3f15d55c26754030feb18032178e5ff3d7bd)
  map.put("_6a44adc74548e99ac32246f1aed58256daf019b2", Res.font._6a44adc74548e99ac32246f1aed58256daf019b2)
  map.put("_6acd0f9f24e86d424fd103ae184d1e4a0589af1b", Res.font._6acd0f9f24e86d424fd103ae184d1e4a0589af1b)
  map.put("_6c49cee9927a527f770b8486b002c85e1cde0588", Res.font._6c49cee9927a527f770b8486b002c85e1cde0588)
  map.put("_6cb50e2d7f94d3c09289fe0bcb4cb5f5f5dd9f27", Res.font._6cb50e2d7f94d3c09289fe0bcb4cb5f5f5dd9f27)
  map.put("_7267c3e070640c379c296cc430d8722abbaa0ae6", Res.font._7267c3e070640c379c296cc430d8722abbaa0ae6)
  map.put("_729c77bb3fe7d444083ba9362ee6d1e7292098da", Res.font._729c77bb3fe7d444083ba9362ee6d1e7292098da)
  map.put("_7321156c853d99243c80be84200b8d1c7064b401", Res.font._7321156c853d99243c80be84200b8d1c7064b401)
  map.put("_750675588f6cf2a66a3c02f0c4045317e42531a7", Res.font._750675588f6cf2a66a3c02f0c4045317e42531a7)
}
